<template>
	<div class="container mt-4">
		<b-overlay :show="loading" no-wrap></b-overlay>
		<b-row>
			<!-- Left column for status summary -->
			<b-col md="4" class="mt-4">
				<!----<h2 class="text-center mb-4">Status Summary</h2>---->
				<div v-for="(status, index) in trackingStatus" :key="index" @click="selectStatus(status)"
					class="status-summary" :class="{ 'selected': selectedStatus.value === status.value }">
					<b-card  text-variant="black" class="mb-2">

						<b-overlay :show="status.loading" no-wrap></b-overlay>
						<div class="status-summary-item">
							<div class="status-color" :style="{ backgroundColor: status.color }"></div>
							<div class="status-details">
								<h5>{{ status.name }}</h5>
								<p>{{ status.count }} Rides</p>
							</div>
						</div>
					</b-card>
				</div>
			</b-col>
			<!-- Right column for displaying rides -->
			<b-col md="8">
				<!----<h2 class="text-center mb-4">Rides</h2>---->
				<b-card v-if="selectedStatus" style="border:none" >
					<b-overlay :show="selectedStatus.loading" no-wrap></b-overlay>
					<h4 class="text-center">{{ selectedStatus.name }}</h4>
					<div v-if="selectedStatus.rides.length > 0" class="ride-list">
						<b-card v-for="(ride, index) in selectedStatus.rides" :key="index" class="mb-2 p-2" :class="{ 'striped': index % 2 !== 0 }">
							<b-row>
								<b-col>
									<p class="text-secondary">
										<b-badge  variant="default" v-if="ride.reservation.operatedBy === 'sc'"> <ScIcon /> {{$t('bookings.shuttleCentralService')}}</b-badge>
										<b-badge  variant="default" v-else><md-icon icon="home" /> <strong>{{$t('bookings.selfService')}}</strong></b-badge>
									</p>
								</b-col>
								<b-col>
									<p class="text-right mr-3 mb-2 text-primary"><md-icon :icon="tripIcon(ride)"/>
										<a href="#" @click="openReservation(ride)" class="text-primary">{{ ride.serviceNumber }}</a>
										| <b-badge :variant="getVariantBystatus(ride.status)">{{ $t("bookings.serviceStatusOpts."+ride.status) }}</b-badge>
									</p>
								</b-col>
							</b-row>
							<p><b>{{ $t("bookings.clientName") }}:</b> {{ ride.reservation.client.firstName }}  {{ ride.reservation.client.lastName }}</p>
							<p><b>{{ $t("bookings.pickupDatetime") }}:</b> {{ ride.pickupDatetime }}</p>
							<p><b>{{ $t("bookings.pickup") }}:</b> {{ ride.pickup.name }}</p>
							<p><b>{{ $t("bookings.dropoff") }}:</b> {{ ride.dropoff.name }}</p>
						</b-card>
					</div>
					<div v-else>
						<p class="text-center">{{ $t("global.ajaxTable.noRecordsFound") }}</p>
					</div>
				</b-card>
				<b-card v-else>
					<p class="text-center">{{ $t("global.selectOption") }}.</p>
				</b-card>
			</b-col>
		</b-row>
		<ResSingle
			ref="single"
			:model-id.sync="reservation.id"
			:show.sync="reservation.show"
			operated-by="supplier"
		/>
	</div>
</template>

<script>
import ResSingle from '../Single.vue';
export default {
	props:{
		driverId:{
			type : Number,
			required: true
		},
	},
	components:{ResSingle},
	data() {
		return {
			loading:false,
			reservation:{
				id:-1,
				show:false
			},
			statuses:[
				{value:'pending',name:this.$t('bookings.trackingStatusOpts.pending'),rides:[],color: 'outline-primary',loading:false},
				{value:'onWayToPickup',name:this.$t('bookings.trackingStatusOpts.onWayToPickup'),rides:[],color: 'primary',loading:false},
				{value:'atPickup',name:this.$t('bookings.trackingStatusOpts.atPickup'),rides:[],color: 'primary',loading:false},
				{value:'onWayToDropoff',name:this.$t('bookings.trackingStatusOpts.onWayToDropoff'),rides:[],color: 'primary',loading:false},
				{value:'finished',name:this.$t('bookings.trackingStatusOpts.finished'),rides:[],color: 'primary',loading:false},
				{value:'noShow',name:this.$t('bookings.trackingStatusOpts.noShow'),rides:[],color: 'primary',loading:false},
			],
			selectedStatus: {value:"",rides:[]},
			rides:[]
		};
	},
	async created() {
		this.loading = true;
		for (let i = this.statuses.length - 1; i >= 0; i--) {
			try {
				await this.selectStatus(this.statuses[i]); // Call selectStatus for each status
			} catch (error) {
				console.error('Error processing status:', error);
			}
		}
		this.loading= false;
		//await this.selectStatus(this.statuses[0])
	},
	computed:{
		trackingStatus(){
			return this.statuses;
		}
	},
	methods: {
		getVariantBystatus(status){
			try{
				let variant = this.$root.auxVars.transportServiceStatusOpts.find((el)=>{
					return el.value==status
				});
				if(variant) return variant.class;
			}catch(err){console.log(err)}
			return "info";
		},
		tripIcon(rideModel) {
			if (rideModel.pickup.isAirport) return "flight_land";
			//A2H
			else if (rideModel.dropoff.isAirport) return "flight_takeoff";
			//H2A
			else return "place"; //P2P
		},
		openReservation(rideModel){
			this.reservation.id =rideModel.reservationId,
			this.reservation.show=true;
		},
		generateRides(count) {
			const rides = [];
			for (let i = 0; i < count; i++) {
				rides.push({ name: `Ride ${i + 1}`, destination: `Destination ${i + 1}`, passenger: `Passenger ${i + 1}` });
			}
			return rides;
		},
		async getRides(status){
			try{
				const response = await this.$root.api
				.get(`/drivers/rto/rides`,{params: {filters:{driverId:this.driverId,trackingStatus:status}}})
				return response.data;
			}catch(error){
				console.error('Error fetching rides:', error);
				return []; // Return an empty array in case of error
			}
		},
		async selectStatus(status) {
			this.selectedStatus = status;
			status.loading = true;
			let rides = await this.getRides(status.value);
			status.rides = rides;
			status.count = rides.length??0;
			status.loading = false;

		},
	}
};
</script>

<style scoped>
.status-summary {
	cursor: pointer;
}
.status-summary.selected .card {
	background-color: blue;
	color: white;
}

.status-summary-item {
	display: flex;
	align-items: center;
}

.status-summary-item.selected {
	background-color: rgba(0, 0, 0, 0.1) !important;
}

.status-color {
	width: 20px;
	height: 20px;
	border-radius: 50%;
	margin-right: 10px;
}

.status-details {
	flex: 1;
}

.card-body{
	padding: 5px !important;
}
p{
	margin: 0.5px;
}
.card{
	border-radius: 1.5rem !important;
}
.striped{
	background-color: #f4f8fc;
}
.ride-list{
	padding: 10px;
	overflow-y: scroll;
    height: 600px;
    background: #f7f7f7;
	border-radius: 1rem;
}
</style>
